<!-- 应用根组件：承载全站配置、路由视图与 AI 助手悬浮入口。 -->
<template>
  <el-config-provider :locale="locale" :size="size">
    <!-- 开启水印 -->
    <el-watermark
      v-if="watermarkEnabled"
      :font="{ color: fontColor }"
      :content="defaultSettings.watermarkContent"
      :z-index="9999"
      class="wh-full"
    >
      <router-view />
    </el-watermark>
    <!-- 关闭水印 -->
    <router-view v-else />
    <AiAssistantFloating />
  </el-config-provider>
</template>

<script setup lang="ts">
import { useAppStore, useSettingsStore } from "@/store";
import defaultSettings from "@/settings";
import { ThemeEnum } from "@/enums/ThemeEnum";
import { SizeEnum } from "@/enums/SizeEnum";
import { usePlatformUsageTracker } from "@/composables/usePlatformUsageTracker";
import AiAssistantFloating from "@/components/AiAssistantFloating/index.vue";

defineOptions({ name: "App" });

const appStore = useAppStore();
const settingsStore = useSettingsStore();

// 启动平台使用时长统计：放在 App 根组件才能覆盖全站页面。
usePlatformUsageTracker();

const locale = computed(() => appStore.locale);
const size = computed(() => appStore.size as SizeEnum);
const watermarkEnabled = computed(() => settingsStore.watermarkEnabled);

// 明亮/暗黑主题水印字体颜色适配
const fontColor = computed(() => {
  return settingsStore.theme === ThemeEnum.DARK
    ? "rgba(255, 255, 255, .15)"
    : "rgba(0, 0, 0, .15)";
});
</script>
